import { render, staticRenderFns } from "./LinsesTitle.vue?vue&type=template&id=27d9020e&"
import script from "./LinsesTitle.vue?vue&type=script&lang=js&"
export * from "./LinsesTitle.vue?vue&type=script&lang=js&"
import style0 from "./LinsesTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports